import { Link } from 'react-router-dom';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="container footer-grid">
          <div className="footer-col">
            <div className="footer-brand">
              <img src="/img/newbirthlogo.png" alt="Logo" />
              <span>New Birth</span>
            </div>
            <p className="footer-about">
              New Birth Church of Christ International is committed to winning souls,
              unifying the Body of Christ, and serving humanity worldwide.
            </p>
            <div className="footer-social">
              <a href="https://twitter.com" aria-label="Twitter" target="_blank" rel="noreferrer">𝕏</a>
              <a href="https://facebook.com" aria-label="Facebook" target="_blank" rel="noreferrer">f</a>
              <a href="https://youtube.com" aria-label="YouTube" target="_blank" rel="noreferrer">▶</a>
              <a href="https://instagram.com" aria-label="Instagram" target="_blank" rel="noreferrer">◻</a>
            </div>
          </div>

          <div className="footer-col">
            <h3>Contact</h3>
            <ul className="footer-list">
              <li>📍 2240 Kipling Avenue, Toronto, Canada</li>
              <li>📞 <a href="tel:+14168579811">+1-416-857-9811</a></li>
              <li>✉ <a href="mailto:nbirthcci@gmail.com">nbirthcci@gmail.com</a></li>
              <li>🕐 Mon – Fri, 8:00 – 9:00</li>
            </ul>
          </div>

          <div className="footer-col">
            <h3>Programs</h3>
            <ul className="footer-list">
              <li><Link to="/programs">Humanitarian Work</Link></li>
              <li><Link to="/programs">Equipping Ministers</Link></li>
              <li><Link to="/programs">Soul Winning Outreaches</Link></li>
              <li><Link to="/programs">Church Licensing</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h3>Quick Links</h3>
            <ul className="footer-list">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/events">Events</Link></li>
              <li><Link to="/board-members">Board Members</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container footer-bottom-inner">
          <p>© {new Date().getFullYear()} New Birth Church of Christ International. All Rights Reserved.</p>
          <p>Toronto, Canada</p>
        </div>
      </div>
    </footer>
  );
}
